const upcomingEvents = [
  {
    eventId: 1,
    event:
      'USC KIIT Research Forum Kick-off! Join us as we dive into collaborative exploration, where your ideas ignite and innovations flourish under the guidance of industry-experienced mentors.',
    date: {
      day: '2',
      month: 'March',
      year: '2024',
    },
    // time: {
    //   start: '8:00 PM',
    //   end: '10:00 PM',
    // },
  },
]

export { upcomingEvents }
